
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

// Update panel headers based on which panel is active
let updatePanelHeaders = function(activePanel) {
    const headers = document.querySelectorAll('.js-panel-header');

    headers.forEach(header => {
        const filterText = header.getAttribute('data-filter-text');
        const sortText = header.getAttribute('data-sort-text');

        if (activePanel === 'option-filter') {
            header.textContent = filterText;
        } else if (activePanel === 'option-sort') {
            header.textContent = sortText;
        }
    });
};

//
let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent('MouseEvent');
    evt.initMouseEvent(
        'click',
        true, /* bubble */
        true, /* cancelable */
        window, null,
        0, 0, 0, 0, /* coordinates */
        false, false, false, false, /* modifier keys */
        0,/*left*/
        null
    );


    let canceled = !elem.dispatchEvent(evt);
};

// Feed function an id and it will tell you if it contains .show class
let isElementOpen = function (elem) {
    if (document.getElementById(elem) == undefined){
        return false;
    }

    if (document.getElementById(elem).classList.contains('show')) {
        return true;
    } else {
        return false;
    }
}

// Remove/add show
let toggleId = function (elem) {
    let el = document.getElementById(elem)
    if (el.classList.contains('show')) {
        el.classList.remove('show')
        document.documentElement.style.height = "unset";
        clearAllBodyScrollLocks();
    } else {
        el.classList.add('show')
        disableBodyScroll(el);
        document.documentElement.style.height = "100%";
    }
}

document.addEventListener('click', function (event) {
    // Make sure clicked element is our toggle

    let el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains('js-options-toggle')) {
        return;
    }
    Alpine.store('general').updateOpenSection('NONE')

    let slideOut = document.getElementById('slideout-options');
    let optionToShowEl = el.getAttribute('data-type-target');

    // Hide all elements for mobile inside the form

    document.querySelectorAll('#form-sidebar-filters .facet__wrapper').forEach(facetEl => {
        if (facetEl.id === optionToShowEl){
            facetEl.classList.remove('d-none')
            facetEl.classList.add('d-flex')
        } else {
            facetEl.classList.add('d-none')
            facetEl.classList.remove('d-flex')
        }
    })

    // Update panel headers based on active panel
    updatePanelHeaders(optionToShowEl);

    if (!isElementOpen("slideout-options")) {
        toggleId("slideout-options")
    }

    let searchIconEl = document.querySelector('.js-search-dropdown-toggle.search-summary-icon-search');
    let closeTriggers = document.querySelectorAll('.js-options-close');

    closeTriggers.forEach(closeEl => {
        closeEl.addEventListener('click', function (e) {
            e.preventDefault()
            // checks to see if anything else is open
            if (isElementOpen("slideout-options")) {
                toggleId("slideout-options")
            }

            clearAllBodyScrollLocks();
        }, false);
    });
})
